import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export function SlackIntegrationErrorPage() {
    return (
        <div className='tb-error-box' style={{ minWidth: 'unset' }}>
            <img
                src={imgPath('Slack_Tableau_lockup.png')}
                alt={Messages.connectToSlack_oAuthError_lockupAltText()}
                style={{ maxWidth: '250px' }}
            />
            <div style={{ marginTop: '64px' }}>
                <div className="tb-error-box-message-first">{Messages.connectToSlack_oAuthError_unableToConnect()}</div>
                <div className="tb-error-box-message-second">{Messages.connectToSlack_oAuthError_tryAgain()}</div>
            </div>
        </div>
    );
}
